var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"229c763dba9aa93008f9d9d29469a93ff5df6092"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["platform-ui@compono"]={id:"229c763dba9aa93008f9d9d29469a93ff5df6092"};
      